const _ = require("ES/lib/lodash");
const radio = require("ES/lib/radio");
const Balboa = require("ES/services/Balboa");
const ServicesUtils = require("ES/utils/ServicesUtils");

module.exports.init = _.once(function () {
  ServicesUtils.RadioAjax(
    "read_Thirdpartyconnection_Stripe_config",
    function (sid, success, failure) {
      Balboa.api(
        "/stripe/getspeakerinfo",
        { speaker_id: sid },
        function (data) {
          success(sid, data.data);
        },
        function (data) {
          failure(sid, (data && data.message) || "unknown cause");
        }
      );
    }
  );

  ServicesUtils.RadioAjax(
    "save_Thirdpartyconnection_Zimbra_config",
    function (sid, data, success, failure) {
      Balboa.api(
        "/thirdpartyconnection/configzimbra/" + sid + "/save",
        {
          zimbra_username: data.zimbra_username,
          zimbra_password: data.zimbra_password,
        },
        function (data) {
          success(sid, data.data);
        },
        function (data) {
          failure(sid, (data && data.message) || "unknown cause");
        }
      );
    }
  );
  ServicesUtils.RadioAjax(
    "read_Thirdpartyconnection_Zimbra_config",
    function (sid, success, failure) {
      Balboa.api(
        "/thirdpartyconnection/configzimbra/" + sid + "/read",
        {},
        function (data) {
          success(sid, data.data);
        },
        function (data) {
          failure(sid, (data && data.message) || "unknown cause");
        }
      );
    }
  );

  ServicesUtils.RadioAjax(
    "save_Thirdpartyconnection_Infusionsoft_config",
    function (sid, data, success, failure) {
      Balboa.api(
        "/thirdpartyconnection/configinfusionsoft/" + sid + "/save",
        {
          app_name: data.app_name,
          app_key: data.app_key,
          infusionsoft_username: data.infusionsoft_username,
          infusionsoft_password: data.infusionsoft_password,
        },
        function (data) {
          success(data.data);
        },
        function (data) {
          failure((data && data.message) || "unknown cause");
        }
      );
    },
    function (sid, data) {
      return sid;
    }
  );
  ServicesUtils.RadioAjax(
    "read_Thirdpartyconnection_Infusionsoft_config",
    function (sid, success, failure) {
      Balboa.api(
        "/thirdpartyconnection/configinfusionsoft/" + sid + "/read",
        {},
        function (data) {
          success(data.data);
        },
        function (data) {
          failure((data && data.message) || "unknown cause");
        }
      );
    },
    function (sid) {
      return sid;
    }
  );

  ServicesUtils.RadioAjax(
    "save_Thirdpartyconnection_SalesForce_config",
    function (sid, data, success, failure) {
      Balboa.api(
        "/thirdpartyconnection/configsalesforce/" + sid + "/save",
        {
          salesforce_username: data.salesforce_username,
          salesforce_password: data.salesforce_password,
          salesforce_api_token: data.salesforce_api_token,
        },
        function (data) {
          success(sid, data.data);
        },
        function (data) {
          failure(sid, (data && data.message) || "unknown cause");
        }
      );
    }
  );
  ServicesUtils.RadioAjax(
    "read_Thirdpartyconnection_SalesForce_config",
    function (sid, success, failure) {
      Balboa.api(
        "/thirdpartyconnection/configsalesforce/" + sid + "/read",
        {},
        function (data) {
          success(sid, data.data);
        },
        function (data) {
          failure(sid, (data && data.message) || "unknown cause");
        }
      );
    }
  );
  ServicesUtils.RadioAjax(
    "save_Thirdpartyconnection_Insightly_config",
    function (sid, data, success, failure) {
      Balboa.api(
        "/thirdpartyconnection/configinsightly/" + sid + "/save",
        {
          insightly_api_token: data.insightly_api_token,
        },
        function (data) {
          success(sid, data.data);
        },
        function (data) {
          failure(sid, (data && data.message) || "unknown cause");
        }
      );
    }
  );
  ServicesUtils.RadioAjax(
    "read_Thirdpartyconnection_Insightly_config",
    function (sid, success, failure) {
      Balboa.api(
        "/thirdpartyconnection/configinsightly/" + sid + "/read",
        {},
        function (data) {
          success(sid, data.data);
        },
        function (data) {
          failure(sid, (data && data.message) || "unknown cause");
        }
      );
    }
  );

  //KARMA
  ServicesUtils.RadioAjax(
    "save_Thirdpartyconnection_KarmaCRM_config",
    function (sid, data, success, failure) {
      Balboa.api(
        "/thirdpartyconnection/configkarmacrm/" + sid + "/save",
        {
          karmacrm_api_token: data.karmacrm_api_token,
        },
        function (data) {
          success(sid, data.data);
        },
        function (data) {
          failure(sid, (data && data.message) || "unknown cause");
        }
      );
    }
  );
  ServicesUtils.RadioAjax(
    "read_Thirdpartyconnection_KarmaCRM_config",
    function (sid, success, failure) {
      Balboa.api(
        "/thirdpartyconnection/configkarmacrm/" + sid + "/read",
        {},
        function (data) {
          success(sid, data.data);
        },
        function (data) {
          failure(sid, (data && data.message) || "unknown cause");
        }
      );
    }
  );

  //ZOHO
  ServicesUtils.RadioAjax(
    "read_Thirdpartyconnection_ZohoCRM_config",
    function (sid, success, failure) {
      Balboa.api(
        "/thirdpartyconnection/configzohocrm/" + sid + "/read",
        {},
        function (data) {
          success(sid, data.data);
        },
        function (data) {
          failure(sid, (data && data.message) || "unknown cause");
        }
      );
    }
  );
  ServicesUtils.RadioAjax(
    "remove_Thirdpartyconnection_ZohoCRM_config",
    function (sid, success, failure) {
      Balboa.api(
        "/thirdpartyconnection/configzohocrm/" + sid + "/remove",
        {},
        function (data) {
          success(sid, data.data);
        },
        function (data) {
          failure(sid, (data && data.message) || "unknown cause");
        }
      );
    }
  );

  //API KEY
  ServicesUtils.RadioAjax(
    "save_Thirdpartyconnection_APIkey_config",
    function (sid, data, success, failure) {
      Balboa.api(
        "/thirdpartyconnection/configapikey/" + sid + "/change",
        {
          confirmreset: true,
        },
        function (data) {
          success(sid, data.data);
        },
        function (data) {
          failure(sid, (data && data.message) || "unknown cause");
        }
      );
    }
  );
  ServicesUtils.RadioAjax(
    "read_Thirdpartyconnection_APIkey_config",
    function (sid, success, failure) {
      Balboa.api(
        "/thirdpartyconnection/configapikey/" + sid + "/read",
        {},
        function (data) {
          success(sid, data.data);
        },
        function (data) {
          failure(sid, (data && data.message) || "unknown cause");
        }
      );
    }
  );

  //GOOGLE CONTACTS
  ServicesUtils.RadioAjax(
    "read_Thirdpartyconnection_Google_config",
    function (sid, success, failure) {
      Balboa.api(
        "/thirdpartyconnection/configgoogle/" + sid + "/read",
        {},
        function (data) {
          success(sid, data.data);
        },
        function (data) {
          failure(sid, (data && data.message) || "unknown cause");
        }
      );
    }
  );

  //HIGH LEVEL
  ServicesUtils.RadioAjax(
    "read_Thirdpartyconnection_Highlevel_config",
    function (sid, success, failure) {
      Balboa.api(
        "/thirdpartyconnection/confighighlevel/" + sid + "/read",
        {},
        function (data) {
          success(sid, data.data);
        },
        function (data) {
          failure(sid, (data && data.message) || "unknown cause");
        }
      );
    }
  );

  //GOOGLE TASKS
  ServicesUtils.RadioAjax(
    "read_Thirdpartyconnection_GoogleTasks_config",
    function (sid, success, failure) {
      Balboa.api(
        "/thirdpartyconnection/configgoogletasks/" + sid + "/read",
        {},
        function (data) {
          success(sid, data.data);
        },
        function (data) {
          failure(sid, (data && data.message) || "unknown cause");
        }
      );
    }
  );

  //HUBSPOT
  ServicesUtils.RadioAjax(
    "read_Thirdpartyconnection_Hubspot_config",
    function (sid, success, failure) {
      Balboa.api(
        "/thirdpartyconnection/confighubspot/" + sid + "/read",
        {},
        function (data) {
          success(sid, data.data);
        },
        function (data) {
          failure(sid, (data && data.message) || "unknown cause");
        }
      );
    }
  );

  ServicesUtils.RadioAjax(
    "remove_Thirdpartyconnection_Hubspot_config",
    function (sid, success, failure) {
      Balboa.api(
        "/thirdpartyconnection/confighubspot/" + sid + "/remove",
        {},
        function (data) {
          success(sid, data.data);
        },
        function (data) {
          failure(sid, (data && data.message) || "unknown cause");
        }
      );
    }
  );

  //TRIPIT
  ServicesUtils.RadioAjax(
    "read_Thirdpartyconnection_TripIt_config",
    function (sid, success, failure) {
      Balboa.api(
        "/thirdpartyconnection/configtripit/" + sid + "/read",
        {},
        function (data) {
          success(sid, data.data);
        },
        function (data) {
          failure(sid, (data && data.message) || "unknown cause");
        }
      );
    }
  );

  //INFUSIONSOFT
  radio("Thirdpartyconnection_Infusionsoft_get_stagetimes").subscribe(function (
    sid
  ) {
    Balboa.api(
      "/thirdpartyconnection/getinfusionsoftstagetimes/" + sid,
      {},
      function (data) {
        radio("Thirdpartyconnection_Infusionsoft_stagetimes").broadcast(
          sid,
          data.data
        );
      },
      function (data) {
        radio(
          "Thirdpartyconnection_Infusionsoft_get_stagetimes_failed"
        ).broadcast(sid, (data && data.message) || "unknown cause");
        console.error(data);
      }
    );
  });

  radio("Thirdpartyconnection_Infusionsoft_get_opportunities").subscribe(
    function (sid, stagetime_id) {
      Balboa.api(
        "/thirdpartyconnection/getinfusionsoftopportunitiesbystage/" + sid,
        {
          stagetime_id: stagetime_id,
        },
        function (data) {
          radio("Thirdpartyconnection_Infusionsoft_opportunities").broadcast(
            sid,
            stagetime_id,
            data.data
          );
        },
        function (data) {
          radio(
            "Thirdpartyconnection_Infusionsoft_get_opportunities_failed"
          ).broadcast(
            sid,
            stagetime_id,
            (data && data.message) || "unknown cause"
          );
          console.error(data);
        }
      );
    }
  );

  radio("Thirdpartyconnection_Infusionsoft_import_opportunities").subscribe(
    function (sid, opportunity_id, status, trash) {
      Balboa.api(
        "/thirdpartyconnection/importinfusionsoftopportunity/" + sid,
        {
          opportunity_id: opportunity_id,
          status: status,
        },
        function (data) {
          radio(
            "Thirdpartyconnection_Infusionsoft_import_opportunities_succeeded"
          ).broadcast(sid, opportunity_id, status, data.event_id);
        },
        function (data) {
          radio(
            "Thirdpartyconnection_Infusionsoft_import_opportunities_failed"
          ).broadcast(
            sid,
            opportunity_id,
            status,
            (data && data.message) || "unknown cause"
          );
          console.error(data);
        }
      );
    }
  );

  //ZOHO
  radio("Thirdpartyconnection_Zoho_get_opportunities").subscribe(function (
    sid,
    searchfor
  ) {
    Balboa.api(
      "/thirdpartyconnection/getzohoopportunitiesbyname/" + sid,
      {
        searchfor,
      },
      function (data) {
        radio("Thirdpartyconnection_Zoho_opportunities").broadcast(
          sid,
          searchfor,
          data.data
        );
      },
      function (data) {
        radio("Thirdpartyconnection_Zoho_get_opportunities_failed").broadcast(
          sid,
          searchfor,
          (data && data.message) || "unknown cause"
        );
        console.error(data);
      }
    );
  });

  radio("Thirdpartyconnection_Zoho_import_opportunities").subscribe(function (
    sid,
    opportunity_id,
    status,
    trash
  ) {
    Balboa.api(
      "/thirdpartyconnection/importzohoopportunity/" + sid,
      {
        opportunity_id: opportunity_id,
        status: status,
      },
      function (data) {
        radio(
          "Thirdpartyconnection_Zoho_import_opportunities_succeeded"
        ).broadcast(sid, opportunity_id, status, data.event_id);
      },
      function (data) {
        radio(
          "Thirdpartyconnection_Zoho_import_opportunities_failed"
        ).broadcast(
          sid,
          opportunity_id,
          status,
          (data && data.message) || "unknown cause"
        );
        console.error(data);
      }
    );
  });

  radio("Thirdpartyconnection_Zoho_link_opportunities").subscribe(function (
    sid,
    opportunity_id,
    status,
    event_id
  ) {
    Balboa.api(
      "/thirdpartyconnection/linkzohoopportunity/" + sid,
      {
        opportunity_id: opportunity_id,
        event_id: event_id,
      },
      function (data) {
        radio(
          "Thirdpartyconnection_Zoho_import_opportunities_succeeded"
        ).broadcast(sid, opportunity_id, status, data.event_id);
      },
      function (data) {
        radio(
          "Thirdpartyconnection_Zoho_import_opportunities_failed"
        ).broadcast(
          sid,
          opportunity_id,
          status,
          (data && data.message) || "unknown cause"
        );
        console.error(data);
      }
    );
  });
});



// WEBPACK FOOTER //
// ./src/services/Thirdpartyconnection.js